import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=6902c32b&scoped=true&"
import script from "./CustomCard.vue?vue&type=script&lang=js&"
export * from "./CustomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6902c32b",
  null
  
)

export default component.exports